import React from "react";
import { Modal, ProgressBar } from "react-bootstrap";
import styled from "styled-components";

const ProgressModalStyled = styled(Modal)`
  .modal-dialog {
    display: flex;
    align-items: center;
    min-height: calc(100vh - 3.5rem);
    margin: 1.75rem auto;
    max-width: 500px;

    @media (max-width: 575px) {
      min-height: calc(100vh - 1rem);
      margin: 0.5rem;
      max-width: calc(100% - 1rem);
    }

    @media (min-width: 576px) and (max-width: 767px) {
      max-width: 540px;
      margin: 1.5rem auto;
    }

    @media (min-width: 768px) and (max-width: 991px) {
      max-width: 600px;
    }

    @media (min-width: 992px) {
      max-width: 600px;
    }
  }

  .modal-content {
    background: rgba(255, 255, 255, 0.98);
    border-radius: 16px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12);
    border: none;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    width: 100%;

    @media (max-width: 575px) {
      border-radius: 12px;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    }

    @media (min-width: 576px) and (max-width: 767px) {
      border-radius: 14px;
    }
  }
`;

const ProgressTitle = styled.h5`
  color: var(--primary);
  margin-bottom: 1.5rem;
  text-align: center;
  font-weight: 600;
  font-size: 1.5rem;

  @media (max-width: 575px) {
    font-size: 1.125rem;
    margin-bottom: 1rem;
  }

  @media (min-width: 576px) and (max-width: 767px) {
    font-size: 1.25rem;
    margin-bottom: 1.25rem;
  }

  @media (min-width: 768px) {
    font-size: 1.375rem;
  }
`;

const ProgressBarStyled = styled(ProgressBar)`
  height: 14px;
  border-radius: 8px;
  background-color: #f0f0f0;
  overflow: hidden;

  .progress-bar {
    background-color: var(--primary);
    animation: progress-bar-stripes 1s linear infinite;
    transition: width 0.3s ease;
  }

  @media (max-width: 575px) {
    height: 10px;
    border-radius: 5px;
  }

  @media (min-width: 576px) and (max-width: 767px) {
    height: 12px;
    border-radius: 6px;
  }
`;

const ProgressText = styled.p`
  text-align: center;
  margin-top: 1.25rem;
  margin-bottom: 0;
  color: #666;
  font-size: 1rem;
  line-height: 1.5;

  @media (max-width: 575px) {
    font-size: 0.875rem;
    margin-top: 0.75rem;
    line-height: 1.4;
  }

  @media (min-width: 576px) and (max-width: 767px) {
    font-size: 0.9375rem;
    margin-top: 1rem;
  }
`;

const ModalBodyStyled = styled(Modal.Body)`
  padding: 2rem;

  @media (max-width: 575px) {
    padding: 1.25rem;
  }

  @media (min-width: 576px) and (max-width: 767px) {
    padding: 1.5rem;
  }

  @media (min-width: 768px) and (max-width: 991px) {
    padding: 1.75rem;
  }
`;

export const ProgressModal = ({ progress }) => {
  if (!progress) return null;

  return (
    <ProgressModalStyled
      show={progress.showProgress}
      centered
      backdrop="static"
      keyboard={false}
      animation={false}
    >
      <ModalBodyStyled>
        <ProgressTitle>{progress.status}</ProgressTitle>
        <ProgressBarStyled
          now={progress.progress}
          animated={progress.progress < 100}
        />
        <ProgressText>
          {progress.progress < 100
            ? `Processing page ${progress.currentPage} of ${progress.totalPages}`
            : "Finalizing your PDF..."}
        </ProgressText>
      </ModalBodyStyled>
    </ProgressModalStyled>
  );
};
